import { CampaignComponentTabs } from './constants';

export type TabItem = {
  label: string;
  value: CampaignComponentTabs;
  disabled?: boolean;
};

export const getTabItems = (disabled: boolean, isDesignTabHidden = false): TabItem[] => {
  const items: TabItem[] = [
    {
      label: 'Configure',
      value: CampaignComponentTabs.Configure,
    },
    {
      label: 'Target',
      value: CampaignComponentTabs.Target,
      disabled: disabled,
    },
  ];

  if (!isDesignTabHidden) {
    items.push({
      label: 'Design',
      value: CampaignComponentTabs.Design,
      disabled: disabled,
    });
  }

  items.push({
    label: 'Schedule',
    value: CampaignComponentTabs.Schedule,
    disabled: disabled,
  });

  return items;
};
